import {
  ClipboardCheckFilledIcon,
  ProfileIcon,
  OrderIcon,
  PaymentFilledIcon,
  ProductAddIcon,
  DiscountFilledIcon,
  DeliveryFilledIcon,
} from "@shopify/polaris-icons";

const settingConfig = (cms) => {
  const config = {
    "/": [
      {
        caption: cms("common.actions.dashboard.caption.profile"),
        label: cms("common.actions.dashboard.label.profile"),
        icon: ProfileIcon,
        link: "/profile",
      },
    ],
    "/orders": [
      {
        caption: cms("common.actions.orders.caption.acceptance"),
        label: cms("common.actions.orders.label.acceptance"),
        icon: OrderIcon,
        link: "/setting/order",
      },
    ],
    "/payments": [
      {
        caption: cms("common.actions.payments.caption.stripe"),
        label: cms("common.actions.payments.label.stripe"),
        icon: PaymentFilledIcon,
        link: "/payment-connect",
      },
      {
        caption: cms("common.actions.payments.caption.paypal"),
        label: cms("common.actions.payments.label.paypal"),
        icon: PaymentFilledIcon,
        link: "/payment-connect",
      },
    ],
    "/products": [
      {
        caption: cms("common.actions.products.caption.autoAdd"),
        label: cms("common.actions.products.label.autoAdd"),
        icon: ProductAddIcon,
        link: "/setting/product",
      },
      {
        caption: cms("common.actions.products.caption.productFormLabel"),
        label: cms("common.actions.products.label.productFormLabel"),
        link: "/setting/product/label",
        icon: ClipboardCheckFilledIcon,
      },
      {
        caption: cms("common.actions.products.caption.discount"),
        label: cms("common.actions.products.label.discount"),
        icon: DiscountFilledIcon,
        link: "/setting/discount",
      },
      {
        caption: cms("common.actions.products.caption.shipping"),
        label: cms("common.actions.products.label.shipping"),
        icon: DeliveryFilledIcon,
        link: "/shipping",
      },
    ],
    "/product-lake": [
      // {
      //   caption: cms("common.actions.products.caption.autoAdd"),
      //   label: cms("common.actions.products.label.autoAdd"),
      //   icon: ProductAddIcon,
      //   link: "/setting/product",
      // },
      // {
      //   caption: cms("common.actions.products.caption.productFormLabel"),
      //   label: cms("common.actions.products.label.productFormLabel"),
      //   link: "/setting/product/label",
      //   icon: ClipboardCheckFilledIcon,
      // },
      // {
      //   caption: cms("common.actions.products.caption.discount"),
      //   label: cms("common.actions.products.label.discount"),
      //   icon: DiscountFilledIcon,
      //   link: "/setting/discount",
      // },
      // {
      //   caption: cms("common.actions.products.caption.shipping"),
      //   label: cms("common.actions.products.label.shipping"),
      //   icon: DeliveryFilledIcon,
      //   link: "/shipping",
      // },
    ],
  };
  const title = {
    "/": cms("common.actions.title.setting"),
    "/orders": cms("common.actions.title.orderSettings"),
    "/payments": cms("common.actions.title.paymentSettings"),
    "/products": cms("common.actions.title.productSettings"),
  };
  return { config, title };
};

export default settingConfig;
